export const TableHead = () => (
  <>
    <colgroup>
      <col style={{ width: '30%' }} />
      <col style={{ width: '11%' }} />
      <col style={{ width: '12%' }} />
      <col style={{ width: '12%' }} />
      <col style={{ width: '12%' }} />
      <col style={{ width: '12%' }} />
      <col style={{ width: '11%' }} />
    </colgroup>
    <thead>
      <tr>
        <th>
          <p>Metric name</p>
        </th>
        <th>
          <p>Type</p>
        </th>
        <th>
          <p>Result</p>
        </th>
        <th>
          <p>Sample size</p>
        </th>
        <th>
          <p>Lower bound</p>
        </th>
        <th>
          <p>Upper bound</p>
        </th>
        <th>
          <p>Outcome</p>
        </th>
      </tr>
    </thead>
  </>
);
